import React, { useEffect, useState, useContext } from 'react';
import { db } from '../../../firebase';
import { collection, getDocs, doc, updateDoc, getDoc, deleteDoc } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Modal, Button, Form } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import EditPlatModal from './EditPlatModal';
import DetailsPlatModal from './DetailsPlatModal';
import { UserContext } from '../../../contexts/UserContext';

const Plats = () => {
    const [plats, setPlats] = useState([]);
    const [filteredPlats, setFilteredPlats] = useState([]);
    const [categoriesMap, setCategoriesMap] = useState({});
    const [selectedPlat, setSelectedPlat] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
    const [categoryFilter, setCategoryFilter] = useState('');
    const [nameFilter, setNameFilter] = useState('');
    const { user } = useContext(UserContext);
    const [currentPage, setCurrentPage] = useState(0);
    const platsPerPage = 10; // Number of plats per page
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [platToDelete, setPlatToDelete] = useState(null);


    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const categoriesCollection = collection(db, 'categorie');
                const categoriesSnapshot = await getDocs(categoriesCollection);
                const categoriesList = categoriesSnapshot.docs.reduce((acc, doc) => {
                    acc[doc.id] = doc.data().nom;
                    return acc;
                }, {});
                setCategoriesMap(categoriesList);
            } catch (error) {
                console.error("Error fetching categories: ", error);
            }
        };

        const fetchPlats = async () => {
            try {
                const platsCollection = collection(db, 'food-items');
                const platsSnapshot = await getDocs(platsCollection);
                const platsList = platsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setPlats(platsList);
                setFilteredPlats(platsList); 
            } catch (error) {
                console.error("Error fetching plats: ", error);
            }
        };

        fetchCategories();
        fetchPlats();
    }, []);

    useEffect(() => {
        // Apply filters when plats or filters change
        let filtered = plats;
        if (categoryFilter) {
            filtered = filtered.filter(plat => plat.categorie === categoryFilter);
        }
        if (nameFilter) {
            filtered = filtered.filter(plat => plat.nom.toLowerCase().includes(nameFilter.toLowerCase()));
        }
        setFilteredPlats(filtered);
    }, [plats, categoryFilter, nameFilter]);

    const openEditModal = (plat) => {
       
        setSelectedPlat(plat);
        setIsEditModalOpen(true);
    };

    const closeEditModal = () => {
        setIsEditModalOpen(false);
        setSelectedPlat(null);
    };

    const openDetailsModal = (plat) => {
        setSelectedPlat(plat);
        setIsDetailsModalOpen(true);
    };

    const closeDetailsModal = () => {
        setIsDetailsModalOpen(false);
        setSelectedPlat(null);
    };

    const handleEditSubmit = async (editedPlat) => {
        console.log("Edited Plat:", editedPlat);

        try {
            if (!editedPlat.id) throw new Error("Missing plat ID");

            const platRef = doc(db, 'food-items', editedPlat.id);
       
            // Ensure all fields are strings
            const platData = {
                ...editedPlat,
                nom: editedPlat.nom.toString(),
                categorie: editedPlat.categorie.toString(),
                prix: editedPlat.prix !== null ? parseFloat(editedPlat.prix).toFixed(2):null,
                description: editedPlat.description.toString(),
                image: editedPlat.image.toString(),
            };

            // Check if the document exists before updating
            const platSnap = await getDoc(platRef);
            if (!platSnap.exists()) {
                throw new Error(`No document to update: ${editedPlat.id}`);
            }

            console.log("Updating plat in Firestore:", platData);
            await updateDoc(platRef, platData);

            // Update local state of plats
            const updatedPlats = plats.map(plat => plat.id === editedPlat.id ? { ...plat, ...platData } : plat);
       
            setPlats(updatedPlats);

            closeEditModal();
        } catch (error) {
            console.error("Error updating plat: ", error);
        }
    };

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const openDeleteModal = (plat) => {
        setPlatToDelete(plat);
        setIsDeleteModalOpen(true);
    };
    
    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
        setPlatToDelete(null);
    };
    
    const handleDeletePlat = async () => {
        if (!platToDelete) return;
    
        try {
            const platRef = doc(db, 'food-items', platToDelete.id);
            await deleteDoc(platRef); // Suppression du document de Firestore
    
            // Mettre à jour la liste des plats localement
            const updatedPlats = plats.filter(plat => plat.id !== platToDelete.id);
            setPlats(updatedPlats);
    
            closeDeleteModal(); // Fermer la modal après suppression
        } catch (error) {
            console.error("Erreur lors de la suppression du plat :", error);
        }
    };

    const handleToggleDisponibility = async (plat) => {
        try {
            const platRef = doc(db, 'food-items', plat.id);
            await updateDoc(platRef, {
                disponible: !plat.disponible
            });

            // Update local state
            const updatedPlats = plats.map(p => p.id === plat.id ? { ...p, disponible: !plat.disponible } : p);
            setPlats(updatedPlats);
        } catch (error) {
            console.error("Error toggling availability: ", error);
        }
    };
    

    const offset = currentPage * platsPerPage;
    const currentPlats = filteredPlats.slice(offset, offset + platsPerPage);
    const pageCount = Math.ceil(filteredPlats.length / platsPerPage);

    return (
        <div id="content-wrapper" className="d-flex flex-column ">
            <div id="content">
                <div className="container-fluid">
                    <h1 className="h3 mb-2 text-gray-800">Les Plats</h1>
                    <br />
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 d-flex  align-items-center">
                            <h6 className="m-0 font-weight-bold  mr-4 title-2">Tous les plats</h6>
                           
                                <select className="form-control w-25 mr-2"  value={categoryFilter} onChange={(e) => setCategoryFilter(e.target.value)}>
                                    <option value="">Toutes les catégories</option>
                                    {Object.entries(categoriesMap).map(([id, nom]) => (
                                        <option key={id} value={id}>{nom}</option>
                                    ))}
                                </select>
                        
                               
                                 <input 
                                type="text" 
                                placeholder="Filtrer par nom" 
                                className="form-control w-25" 
                                value={nameFilter}
                                onChange={(e) => setNameFilter(e.target.value)}
                            />
                            
                        
                        </div>
                        <div className="card-body">
                        
                            <div className="table-responsive">
                                <table className="table table-bordered" id="dataTable" width="100%">
                                    <thead>
                                        <tr>
                                            <th>Image</th>
                                            <th>Nom</th>
                                            <th>Catégorie</th>
                                            <th>Prix</th>
                                            <th>Description</th>
                                            <th>Disponible</th>
                                            <th>végétarien</th>
                                            <th width='13%'>Action</th>
                                        </tr>
                                    </thead>
                                    <tfoot>
                                        <tr>
                                            <th>Image</th>
                                            <th>Nom</th>
                                            <th>Catégorie</th>
                                            <th>Prix</th>
                                            <th>Description</th>
                                            <th>Disponible</th>
                                            <th>végétarien</th>
                                            <th>Action</th>
                                        </tr>
                                    </tfoot>
                                    <tbody>
                                        {currentPlats.map(plat => (
                                            <tr key={plat.id}>
                                                <td> 
                                                {plat.image  && (   
                                                    <img className="img-plat" src={plat.image} alt={plat.nom} />
                                                )}</td>
                                                <td>{plat.nom}</td>
                                                <td>{categoriesMap[plat.categorie]}</td>
                                                <td> {plat?.prixType === 'variable' 
                                                ? plat.sizes.map(size => `${size.prix}€`).join(' - ') 
                                                : `${plat.prix}€`}</td>
                                                <td style={{ whiteSpace: 'pre-line' }}>{plat.description}</td>
                                                <td> <Button 
                                                        variant={plat.disponible ? 'success' : 'danger'} 
                                                        onClick={() => handleToggleDisponibility(plat)}
                                                    >
                                                        {plat.disponible ? 'Actif' : 'Inactif'}
                                                    </Button></td>
                                                <td>{plat.vegetarienne ? 'Oui' : 'Non'}</td>
                                                <td className='wth-100'>
                                                    <button onClick={() => openDetailsModal(plat)} className="btn btn-info btn-circle btn-sm mr-2">
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </button>
                                                    {user && user.role === 'L1QUmxerXDdx3DbWgY5H' && (
                                                     <>
                                                     <button onClick={() => openEditModal(plat)} className="btn btn-primary btn-circle btn-sm mr-2">
                                                         <FontAwesomeIcon icon={faEdit} />
                                                     </button>
                                                     <button onClick={() => openDeleteModal(plat)} className="btn btn-danger btn-circle btn-sm">
                                                         <FontAwesomeIcon icon={faTrashAlt} />
                                                     </button>
                                                     </>
                                                )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <ReactPaginate
                                    previousLabel={'Précédent'}
                                    nextLabel={'Suivant'}
                                    breakLabel={'...'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination justify-content-start'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* delete modal  */}
            <Modal show={isDeleteModalOpen} onHide={closeDeleteModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmer la suppression</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Êtes-vous sûr de vouloir supprimer le plat "{platToDelete?.nom}" ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeDeleteModal}>
                        Annuler
                    </Button>
                    <Button variant="danger" onClick={handleDeletePlat}>
                        Supprimer
                    </Button>
                </Modal.Footer>
            </Modal>



            {isEditModalOpen && (
                <EditPlatModal
                    selectedPlat={selectedPlat}
                    categoriesMap={categoriesMap}
                    onClose={closeEditModal}
                    onSubmit={handleEditSubmit}
                    show={isEditModalOpen}
                />
            )}
            {isDetailsModalOpen && (
                <DetailsPlatModal
                    selectedPlat={selectedPlat}
                    categoriesMap={categoriesMap}
                    onClose={closeDetailsModal}
                    show={isDetailsModalOpen}
                />
            )}
        </div>
    );
};

export default Plats;
